module.exports = __webpack_public_path__ + "static/media/more-services.07f0577f.jpg";